export default "__VITE_ASSET__1aH0sUQ___"